module.exports = __webpack_public_path__ + "static/media/jasmine.74b2ca2b.webp";